import styled from "styled-components";

export const JobInfo = styled.div`
    .wrap {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        text-align: left;
    }
`;

export const InputContent = styled.div`
    .bar {
        border-top: 0.5px solid #ccc;
        margin: 1rem 0;
    }
`;

export const Table = styled.table`
    border-collapse: collapse;
    background: white;
    border-radius: 10px;
    overflow: auto;
    width: 100%;
    margin: 0.6rem auto;
    border-collapse: collapse;

    thead th {
        color: #858796;
        font-weight: bold;
        text-align: left;
        vertical-align: bottom;
        border-bottom: 2px solid #e3e6f0;
    }

    tbody tr {
        height: 50px;
        font-family: Roboto, sans-serif;
        font-size: 15px;
        color: #808080;
        line-height: 1.2;
        font-weight: unset;
    }

    th,
    td {
        padding: 0.75rem;
        border: 1px solid #e3e6f0;
    }

    tbody tr:hover {
        color: #555555;
        background-color: #f5f5f5;
    }
    a {
        text-decoration: none;
    }
`;

export const Dropzone = styled.div`
    padding: 1rem;
    margin: 0 auto;

    header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #dddddd;
    }

    .align {
        display: flex;
        align-items: center;
        justify-content: space-around;

        i {
            margin: 1rem;
        }
    }
`;

export const Content = styled.main`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin: 2rem 0;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const DownloadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #2e2e2e;

    button {
        background: #fe8418;
        border-bottom: 2px solid #d36300;
        border-radius: 2rem;
        color: #fff;
        margin-top: 0.5rem;

        padding: 0.6rem 6rem;

        svg {
            margin-right: 1rem;
        }
    }
`;

export const HelpContainer = styled.div`
    margin-left: 10rem;
    margin-top: 1.4rem;

    p {
        color: #fe8418;
        font-weight: 600;
    }

    ul {
        list-style: disc;
        margin-left: 2rem;
        color: #2e2e2e;
    }

    @media (max-width: 760px) {
        margin-left: 20rem;
    }

    @media (max-width: 420px) {
        margin: 0 auto;
    }
`;
